export default __webpack_public_path__ + "media/images/social-linkedin-6438dd72075f812588919fd7b7d24189.svg";